import { render, staticRenderFns } from "./Item62Chekin.vue?vue&type=template&id=0d18772a&"
import script from "./Item62Chekin.vue?vue&type=script&lang=js&"
export * from "./Item62Chekin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports